export enum TimesheetRequestBtnPermission {
    CURRENT_PAYPERIOD = 'CURRENT_PAYPERIOD',
    PAST_PAYPERIOD = 'PAST_PAYPERIOD',
}